module.exports = __webpack_public_path__ + "img/canal.40879193.png";